import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./NewsBottomCard.scss";
import fallbackImg from '../../../Assets/Home/img/HomeNews/image 17.png';
import { formatDate } from "../../../Modules/GeneralModule/GeneralLogic";

const NewsBottomCard = ({ newsData }) => {
  const navigate = useNavigate()
  // Часть записей в API приходит с image_small = /uploads/1 — это 404, и
  // браузер рисовал иконку битой картинки. Данные не трогаем: прячем img и
  // оставляем ровную плитку на её месте, геометрия карточки не меняется.
  const [imgBroken, setImgBroken] = useState(false);

  if (!newsData) {
    return null;
  }

  const maxLength = 150;

  const getSnippet = (htmlContent) => {
    if (!htmlContent) return '';
    if (htmlContent.length <= maxLength) {
      return htmlContent;
    }
    return htmlContent.slice(0, maxLength) + '...';
  };

  return (
    <div className="newsBottomCard_block" onClick={()=> navigate(`/newsItem/${newsData.id}`)}>
      {imgBroken ? (
        <span className="newsBottomCard_img newsBottomCard_img--empty" aria-hidden="true" />
      ) : (
        <img
          src={newsData.image_small || fallbackImg}
          alt=""
          className="newsBottomCard_img"
          /* width/height дублируют css: браузер знает пропорции до загрузки */
          width="300"
          height="300"
          loading="lazy"
          onError={() => setImgBroken(true)}
        />
      )}
      <div className="newsBottomCard_item">
        <div className="newsBottomCardData_block">
          <h6>{formatDate(newsData.created_at)}</h6>
        </div>
        {/* newsData здесь — одна новость, а не список: было newsData[0]?.title,
            из-за чего заголовок у всех карточек был пустым */}
        <h2>{newsData.title}</h2>

          <p dangerouslySetInnerHTML={{ __html: getSnippet(newsData.text) }}></p>

      </div>
    </div>
  );
};

export default NewsBottomCard;
